"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhoneNumberTextMask = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var Base_1 = require("../Base");
var PHONE_NUMBER_MASK = [
    '(',
    /[1-9]/,
    /\d/,
    /\d/,
    ')',
    ' ',
    /\d/,
    /\d/,
    /\d/,
    '-',
    /\d/,
    /\d/,
    /\d/,
    /\d/,
];
exports.PhoneNumberTextMask = function (_a) {
    var _b = _a.mask, mask = _b === void 0 ? PHONE_NUMBER_MASK : _b, rest = tslib_1.__rest(_a, ["mask"]);
    return react_1.default.createElement(Base_1.TextMask, tslib_1.__assign({}, rest, { mask: mask }));
};
exports.PhoneNumberTextMask.displayName = 'FOS_PhoneNumberTextMask';
